import React from 'react';

import { SharedDataProvider } from './Contexts/SharedContext';
import { LanguageProvider } from './Contexts/LanguageContext';
import { ThemeProvider } from './Contexts/ThemeContext';

const Providers = ({ children }) => {
    return (
        <SharedDataProvider>
            <LanguageProvider>
                <ThemeProvider>
                    {children}
                </ThemeProvider>
            </LanguageProvider>
        </SharedDataProvider>
    );
}

export default Providers;